<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<form
  #df="ngForm"
  novalidate
  (keydown.enter)="searchCustomerKycVerification()"
  class="formborder"
>
  <div class="row m-0">
    <div class="col-md-2">
      <span class="required-lable">From Date</span>
      <div class="datepicker_feild">
        <input
          [matDatepicker]="picker"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="VoucherDateFrom"
          [(ngModel)]="VoucherDateFrom"
          id="VoucherDateFrom"
          class="form-control input-text-css"
          (dateChange)="DateChange()"
          required
          #refVoucherDateFrom="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && refVoucherDateFrom.invalid,
            'alert-warning':
              refVoucherDateFrom.invalid &&
              (refVoucherDateFrom.dirty ||
                refVoucherDateFrom.touched ||
                refVoucherDateFrom.untouched)
          }"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>

    <div class="col-md-2">
      <span class="required-lable">To Date</span>
      <div class="datepicker_feild">
        <input
          [matDatepicker]="picker2"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="VoucherDateTo"
          [(ngModel)]="VoucherDateTo"
          id="VoucherDateTo"
          class="form-control input-text-css"
          (dateChange)="DateChange()"
          required
          #reffVoucherDateTo="ngModel"
          [ngClass]="{
            'is-invalid': df.submitted && reffVoucherDateTo.invalid,
            'alert-warning':
              reffVoucherDateTo.invalid &&
              (reffVoucherDateTo.dirty ||
                reffVoucherDateTo.touched ||
                reffVoucherDateTo.untouched)
          }"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
    </div>
    <div class="col-md-2 mt-4">
          <div class="d-flex align-items-center" style="gap: 0.75rem; height: 2.125rem; margin-bottom: 0.75rem;">
            <button
        type="button"
        (click)="searchCustomerKycVerification()"
        class="search-btn"
        style="height: 2rem; margin-bottom: 0.75rem !important;"
        [disabled]="!df.form.valid"
      >
        <i class="fas fa-search"></i> Search
      </button>
          </div>
        </div>
  </div>
</form>

<div class="row m-0 mb-3" [hidden]="!DataSource">
  <!-- Opening Balance -->
  <div class="col-md col-sm-6 p-1">
    <div class="summary-metric-card border-left-blue">
      <div class="metric-info">
        <span class="metric-title">Opening Balance</span>
        <h5 class="metric-number">{{ KycDetails?.OP_Balance || '0.00' }}</h5>
      </div>
    </div>
  </div>
  
  <!-- Add: Recharge Amount -->
  <div class="col-md col-sm-6 p-1">
    <div class="summary-metric-card border-left-green">
      <div class="metric-info">
        <span class="metric-title">Recharge Amount (Add)</span>
        <h5 class="metric-number text-success">+ {{ KycDetails?.Recharge_Amount || '0.00' }}</h5>
      </div>
    </div>
  </div>

  <!-- Total -->
  <div class="col-md col-sm-6 p-1">
    <div class="summary-metric-card border-left-indigo">
      <div class="metric-info">
        <span class="metric-title">Total</span>
        <h5 class="metric-number">{{ KycDetails?.Total || '0.00' }}</h5>
      </div>
    </div>
  </div>

  <!-- Less: Used During Period -->
  <div class="col-md col-sm-6 p-1">
    <div class="summary-metric-card border-left-amber">
      <div class="metric-info">
        <span class="metric-title">Used During Period (Less)</span>
        <h5 class="metric-number text-warning">- {{ KycDetails?.Used_During_Period_Amount || '0.00' }}</h5>
      </div>
    </div>
  </div>

  <!-- Closing Balance -->
  <div class="col-md col-sm-6 p-1">
    <div class="summary-metric-card border-left-brand">
      <div class="metric-info">
        <span class="metric-title">Closing Balance</span>
        <h5 class="metric-number text-primary">{{ KycDetails?.CL_Balance || '0.00' }}</h5>
      </div>
    </div>
  </div>
</div>

<div class="table-responsive mt-3" [hidden]="!DataSource" style="height: 21.875rem; overflow: auto">
      <table
        mat-table
        class="table-bordered"
        matSort
        [dataSource]="DataSource"
        matTableExporter
        #exporter="matTableExporter"
      >
        <ng-container matColumnDef="TYPE">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row">{{ row.TYPE }}</td>
          <th mat-footer-cell *matFooterCellDef></th>
        </ng-container>

        <ng-container matColumnDef="Step_Name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Step Name</th>
          <td mat-cell *matCellDef="let row">{{ row.Step_Name }}</td>
          <th mat-footer-cell *matFooterCellDef></th>
        </ng-container>

        <ng-container matColumnDef="Hit">
          <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: right; justify-content: flex-end; padding-right: 1rem !important;">HIT</th>
          <td mat-cell *matCellDef="let row" style="text-align: right; padding-right: 1rem !important;">
            {{ row.Hit }}
          </td>
          <th mat-footer-cell *matFooterCellDef style="text-align: right; padding-right: 1rem !important;">Total:</th>
        </ng-container>

        <ng-container matColumnDef="Rate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: right; justify-content: flex-end; padding-right: 1rem !important;">Rate</th>
          <td mat-cell *matCellDef="let row" style="text-align: right; padding-right: 1rem !important;">
            {{ row.Rate }}
          </td>
          <th mat-footer-cell *matFooterCellDef style="text-align: right; padding-right: 1rem !important;"></th>
        </ng-container>

        <ng-container matColumnDef="Amount">
          <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align: right; justify-content: flex-end; padding-right: 1rem !important;">Amount</th>
          <td mat-cell *matCellDef="let row" style="text-align: right; padding-right: 1rem !important;">
            {{ row.Amount }}
          </td>
          <th mat-footer-cell *matFooterCellDef style="text-align: right; padding-right: 1rem !important;">
            {{ calculateTotalAmount() }}
          </th>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="sticky-header"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr
          mat-footer-row
          class="sticky-footer"
          *matFooterRowDef="displayedColumns; sticky: true"
        ></tr>
      </table>
    </div>
